import React, { useEffect } from "react"

const useMobileScrollSync = (
  isMobile: boolean,
  stepRefs: React.MutableRefObject<(HTMLDivElement | null)[]>,
  current: number,
  setCurrent: (index: number) => void
) => {
  useEffect(() => {
    if (!isMobile) return

    const headerOffset = 140 // подстрой под высоту шапки + tabsWrapper

    const handleMobileScroll = () => {
      let closestIndex = 0
      let closestDelta = Infinity

      stepRefs.current.forEach((el, index) => {
        if (!el) return

        const rect = el.getBoundingClientRect()
        const delta = Math.abs(rect.top - headerOffset)

        if (delta < closestDelta) {
          closestDelta = delta
          closestIndex = index
        }
      })

      if (closestIndex !== current) {
        setCurrent(closestIndex)
      }
    }

    window.addEventListener("scroll", handleMobileScroll, { passive: true })
    handleMobileScroll() // сразу подсветим правильный таб

    return () => window.removeEventListener("scroll", handleMobileScroll)
  }, [isMobile, current, setCurrent, stepRefs])
}

export default useMobileScrollSync
